import {
  faMosquito, faTent, faTriangleExclamation, faChartLine,
} from '@fortawesome/pro-light-svg-icons'

import Badge from '@App/components/Badge/Badge'

const NAV_ITEMS = [
  {
    pathName: 'mission-setup',
    title: 'Mission setup',
    icon: faTent,
    children: [
      { pathName: 'add-custom-data', title: 'Add custom data' },
      { pathName: 'add-breeding-site', title: 'Add breeding site' },
    ],
  },
  {
    pathName: 'alerts',
    title: 'Alerts',
    icon: faTriangleExclamation,
    badge: ({ counter }) => <Badge type="danger">{counter}</Badge>,
    children: [
      { pathName: 'add-alert', title: 'Add new alert' },
    ],
  },

  '',
  {
    pathName: 'mosquito-observations',
    title: 'Mosquito observations',
    icon: faMosquito,
    iconSize: '28px',
  },
  {
    pathName: 'lab-results',
    title: 'Lab results',
    icon: '/img/icons/nav/mosquito-virus.svg',
    iconSize: '30px',
  },
  '',
  {
    pathName: 'data',
    title: '',
    icon: faChartLine,
    disabled: true,
  },
  {
    pathName: 'module',
    title: 'Module',
    icon: '/img/icons/nav/module.svg',
    disabled: true,
  },
]

export {
  NAV_ITEMS,
}
